function getWCSHost(config) {
    return typeof window === 'undefined' ? config.wcs.internal : config.wcs.external;
}

export default getWCSHost;
